import { render, staticRenderFns } from "./form-article-to-group.vue?vue&type=template&id=099f6b1e"
import script from "./form-article-to-group.vue?vue&type=script&lang=js"
export * from "./form-article-to-group.vue?vue&type=script&lang=js"
import style0 from "./form-article-to-group.vue?vue&type=style&index=0&id=099f6b1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports